import { render, staticRenderFns } from "./CreditorsReport.vue?vue&type=template&id=96669b52&scoped=true&"
import script from "./CreditorsReport.vue?vue&type=script&lang=js&"
export * from "./CreditorsReport.vue?vue&type=script&lang=js&"
import style0 from "./CreditorsReport.vue?vue&type=style&index=0&id=96669b52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96669b52",
  null
  
)

export default component.exports